export default __webpack_public_path__ + "static/media/gn.afea6cea.svg";